// AI 提示词 + 最小可用 HTML 模板（用于自定义HTML 整页直出场景）
// 整页直出时后端会注入 window.QR_CTX，包含：
//   page_uuid, batch_uuid, submit_url, lang,
//   whatsapp_number, whatsapp_message, support_email, verification_code, contact_ref

export const QR_CTX_DOC = `整页直出模式下，后端会自动在页面注入全局变量 window.QR_CTX：
{
  page_uuid:    当前页面UUID,
  batch_uuid:   当前批次UUID,
  submit_url:   订阅提交接口地址（POST JSON）,
  lang:         当前语言码,
  whatsapp_number:  WhatsApp号码（可能为空）,
  whatsapp_message: WhatsApp预设消息,
  support_email:    客服邮箱,
  verification_code: 验证码,
  contact_ref:  归因标识，形如 [#R15-2e-dwgay-zh]（每次页面加载生成，随机变化）
}
你生成的脚本应直接读取 window.QR_CTX，不要硬编码任何 UUID 或地址。`

// 订阅表单
export const SUBSCRIBE_FORM = {
  title: '订阅表单',
  prompt: `这是一个「订阅表单」的后端对接要求（只规定功能与数据契约，样式请沿用你正在生成页面的整体风格，不要额外指定）：
1. 表单需采集 姓名(name) 和 邮箱(email)，可选“同意订阅”勾选框。
2. 提交时用 fetch POST 到 window.QR_CTX.submit_url，请求头 Content-Type: application/json，
   body 为 JSON：{ name, email, browser_language: navigator.language, batch_uuid: window.QR_CTX.batch_uuid,
   contact_ref: window.QR_CTX.contact_ref }（contact_ref 必须原样带上，后台靠它通知本页面自动跳转第二页）
3. 处理返回：
   - { success:true } → 表示提交成功（提示用户查收邮箱并回复验证码）。
   - { success:false, duplicate:true } → 该邮箱已订阅。
   - 其他 → 使用返回的 message 或通用失败提示。
4. 提交期间禁用提交按钮，防止重复提交。
请勿硬编码任何 UUID 或接口地址，一律从 window.QR_CTX 读取。`,
  template: `<!-- 裸结构，样式自行套用页面风格；核心是 JS 对接逻辑 -->
<form id="qr-subscribe">
  <input id="qr-name" type="text" placeholder="姓名" required />
  <input id="qr-email" type="email" placeholder="邮箱" required />
  <label><input id="qr-agree" type="checkbox" checked /> 同意订阅</label>
  <button type="submit">提交</button>
  <p id="qr-msg" hidden></p>
</form>
<script>
(function(){
  var f=document.getElementById('qr-subscribe');
  var msg=document.getElementById('qr-msg');
  f.addEventListener('submit',async function(e){
    e.preventDefault();
    var btn=f.querySelector('button[type=submit]'); btn.disabled=true;
    try{
      var res=await fetch(window.QR_CTX.submit_url,{
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          name:document.getElementById('qr-name').value,
          email:document.getElementById('qr-email').value,
          browser_language:navigator.language,
          batch_uuid:window.QR_CTX.batch_uuid,
          contact_ref:window.QR_CTX.contact_ref||''
        })
      });
      var d=await res.json();
      msg.hidden=false;
      if(d.success){ msg.textContent='提交成功，请查收邮箱并回复验证码。'; }
      else if(d.duplicate){ msg.textContent='该邮箱已订阅。'; }
      else { msg.textContent=d.message||'提交失败'; }
    }catch(err){ msg.hidden=false; msg.textContent='网络错误，请重试。'; }
    btn.disabled=false;
  });
})();
</script>`,
}

// WhatsApp 按钮
export const WHATSAPP_BTN = {
  title: 'WhatsApp 联系按钮',
  prompt: `这是一个「WhatsApp 联系按钮」的后端对接要求（只规定功能，样式沿用页面整体风格，不要额外指定）：
1. 从 window.QR_CTX 读取 whatsapp_number 和 whatsapp_message。
2. 若 whatsapp_number 为空，则隐藏该按钮（不显示）。
3. 点击后在新标签页打开：https://wa.me/<number>?text=<encodeURIComponent(message)>。
请勿硬编码号码，一律从 window.QR_CTX 读取。`,
  template: `<!-- 裸结构，样式自行套用页面风格 -->
<a id="qr-wa" target="_blank" rel="noopener" hidden>WhatsApp 联系我们</a>
<script>
(function(){
  var n=window.QR_CTX.whatsapp_number;
  if(!n)return;
  var a=document.getElementById('qr-wa');
  a.href='https://wa.me/'+n+'?text='+encodeURIComponent(window.QR_CTX.whatsapp_message||'');
  a.hidden=false;
})();
</script>`,
}

// 邮件联系按钮
export const EMAIL_BTN = {
  title: '邮件联系按钮',
  prompt: `这是一个「邮件联系按钮」的后端对接要求（只规定功能，样式沿用页面整体风格，不要额外指定）：
1. 从 window.QR_CTX 读取 support_email、verification_code 和 contact_ref。
2. 若 support_email 为空则隐藏按钮。
3. 点击后通过 mailto: 打开邮件客户端。
4. 邮件主题必须同时包含两项：验证码 verification_code 和归因标识 contact_ref，中间空格分隔，
   形如：「1688 [#R15-2e-dwgay-zh]」。contact_ref 是后端为本次访问生成好的完整标识，
   必须原样使用 window.QR_CTX.contact_ref，禁止自行拼接或修改其中的任何一段。
5. 邮件正文同样带上验证码与 contact_ref。
请勿硬编码邮箱，一律从 window.QR_CTX 读取。`,
  template: `<!-- 裸结构，样式自行套用页面风格 -->
<a id="qr-mail" hidden>邮件联系我们</a>
<script>
(function(){
  var e=window.QR_CTX.support_email;
  if(!e)return;
  var vc=window.QR_CTX.verification_code||'';
  var ref=window.QR_CTX.contact_ref||'';
  var tag=(vc+' '+ref).trim();
  var a=document.getElementById('qr-mail');
  a.href='mailto:'+e+'?subject='+encodeURIComponent(tag)+'&body='+encodeURIComponent(tag);
  a.hidden=false;
})();
</script>`,
}

export const AI_PROMPT_SECTIONS = [SUBSCRIBE_FORM, WHATSAPP_BTN, EMAIL_BTN]

// ============ 第二页（激活/评星页）专用 ============
// 整页直出时，后端会向第二页注入 window.QR_CTX（面向评分）：
//   token, rate_url, review_link, lang, review_threshold
export const QR_CTX_DOC_P2 = `第二页（激活/评星页）整页直出模式下，后端会自动注入全局变量 window.QR_CTX：
{
  token:            当前订阅激活 token,
  rate_url:         评分/留评上报接口地址（POST JSON）,
  review_link:      外部留评链接（可能为空）,
  lang:             当前语言码,
  review_threshold: 触发引导留评的最低星级（默认 5）
}
你生成的脚本应直接读取 window.QR_CTX，不要硬编码任何接口地址或 token。`

// 星级评分 + 留评跳转
export const RATING_SECTION = {
  title: '星级评分 + 留评跳转',
  prompt: `这是一个「星级评分 + 留评跳转」的后端对接要求（只规定功能与数据契约，样式请沿用你正在生成页面的整体风格，不要额外指定）：
1. 展示 1-5 颗星星供用户点选；用户选中 n 颗后立即高亮前 n 颗，并禁止再次点击（只能评一次）。
2. 点选后用 fetch POST 到 window.QR_CTX.rate_url，请求头 Content-Type: application/json，
   body 为 JSON：{ star_rating: n }。
3. 若 n >= window.QR_CTX.review_threshold 且 window.QR_CTX.review_link 非空：
   - 显示一个「去留评」按钮与倒计时文案（如 5 秒）；
   - 倒计时结束或用户主动点击按钮时，先 fetch POST { review_clicked: true } 到 rate_url，再跳转到 review_link。
4. 若 n < review_threshold，显示一段低分感谢文案，不跳转。
请勿硬编码任何接口地址或留评链接，一律从 window.QR_CTX 读取。`,
  template: `<!-- 裸结构，样式自行套用页面风格；核心是 JS 对接逻辑 -->
<div id="qr-rate">
  <p id="qr-rate-prompt">您对我们的产品评价如何？</p>
  <div id="qr-stars">
    <span data-v="1">★</span><span data-v="2">★</span><span data-v="3">★</span><span data-v="4">★</span><span data-v="5">★</span>
  </div>
  <div id="qr-review" hidden>
    <p>感谢您！期待您的评价。</p>
    <p id="qr-countdown"></p>
    <a id="qr-review-btn">去留评</a>
  </div>
  <p id="qr-lowrate" hidden>感谢您的反馈。</p>
</div>
<script>
(function(){
  var CTX=window.QR_CTX||{};
  var selected=0,timer=null;
  var stars=document.getElementById('qr-stars');
  stars.addEventListener('click',async function(e){
    var v=e.target.dataset.v; if(!v||selected) return;
    selected=parseInt(v);
    stars.querySelectorAll('span').forEach(function(s,i){ s.classList.toggle('active',i<selected); });
    try{ await fetch(CTX.rate_url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({star_rating:selected})}); }catch(e){}
    var threshold=CTX.review_threshold||5;
    if(selected>=threshold){
      var box=document.getElementById('qr-review'); box.hidden=false;
      var btn=document.getElementById('qr-review-btn');
      if(CTX.review_link){
        btn.href=CTX.review_link;
        var sec=5, ct=document.getElementById('qr-countdown');
        ct.textContent=sec+'s...';
        timer=setInterval(function(){
          sec--;
          if(sec<=0){ clearInterval(timer);
            fetch(CTX.rate_url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({review_clicked:true})});
            window.location.href=CTX.review_link; ct.textContent='';
          } else { ct.textContent=sec+'s...'; }
        },1000);
      }
      btn.addEventListener('click',function(){ if(timer)clearInterval(timer);
        fetch(CTX.rate_url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({review_clicked:true})}); });
    } else { document.getElementById('qr-lowrate').hidden=false; }
  });
})();
</script>`,
}

export const AI_PROMPT_SECTIONS_P2 = [RATING_SECTION]
